import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../../styles/colors';
import { ZeeFontMedium, ZeeFontRegular } from '../../../styles/font';
import * as pageStyle from '../../../styles/PageStyles/subscriptionPageStyle';
import * as planStyle from '../SubscriptionStyle';

const popupContent = css`
  display: flex;
  flex-direction: column;
`;

const subscriptionContainer = css`
  padding: 60px 24px 32px;
  flex: 1;
  z-index: 1;
`;
const paymentContainer = css`
  padding: 22px 24px;
  background: ${colors.SearchCardBg};
  display: flex;
  border-radius: 0 0 8px 8px;
`;
const headerTitle = css`
  ${ZeeFontMedium(18, 24)}
  color: ${colors.NewSubscriptionCouponText};
`;
const headerDescription = css`
  ${ZeeFontMedium(14, 22)}
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;

export const plansCard = css`
  ${planStyle.planBox}
  position: relative;
  cursor: pointer;
`;

export const backgroundGridImage = css`
  width: 93%;
  border-radius: 8px;
`;

export const PopupContent = styled.div`
  ${popupContent}
`;
export const SubscriptionContainer = styled.div`
  ${subscriptionContainer}
`;
export const PaymentContainer = styled.div`
  ${paymentContainer}
`;
export const HeaderTitle = styled.div`
  ${headerTitle}
`;
export const HeaderDescription = styled.div`
  ${headerDescription}
`;
export const selectedPlanStyle = (isActive: boolean) => css`
  ${plansCard};
  ${isActive ? `border: 1.5px solid ${colors.PurpleLight}` : ''}
`;
export const PlanBox = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  gap: 20px;
`;

export const Suggested = styled.div`
  ${ZeeFontRegular(10, 18)}
  background: linear-gradient(
      270deg,
      #5730c7,
      #5c2ade 48.11%,
      #2928d4 94.83%
    );
  border-radius: 3px 3px 0 0;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  color: ${colors.white};
  left: 50%;
  margin-left: -25%;
  padding: 5px 10px;
  position: absolute;
  top: -28px;
`;
export const TickIcon = styled.span`
  ${planStyle.tickIcon}
`;
export const SelectedPlanTick = styled.div`
  background-color: ${colors.white};
  border-radius: 50%;
  color: ${colors.Purple};
  padding: 6px;
  position: absolute;
  right: -7px;
  top: -12px;
  z-index: 99;
  width: 30px;
`;

export const Selectbg2 = styled.div`
  background: linear-gradient(
    270deg,
    rgba(87, 48, 199, 0.4),
    rgba(92, 42, 222, 0.4) 48.11%,
    rgba(41, 40, 212, 0.4) 94.83%
  );
  height: 76%;
  border-radius: 20px 0 48px 160px;
`;

export const Selectbg = styled.div`
  background: linear-gradient(
    270deg,
    rgba(87, 48, 199, 0.4),
    rgba(92, 42, 222, 0.4) 48.11%,
    rgba(41, 40, 212, 0.4) 94.83%
  );
  height: 76%;
  border-radius: 15px 0 48px 160px;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export const PlanDetailsContainer = styled.div`
  align-items: center;
  background: ${colors.Transparent};
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0 16px;
  width: 100%;
  z-index: 99;
  div {
    z-index: inherit;
  }
`;

export const PremiumButton = styled.button`
  ${planStyle.Button};
  flex: 1;
`;

export const DiscountedPrice = styled.div`
  ${planStyle.discountedPrice};
  min-height: 24px;
`;
export const Price = styled.div`
  ${planStyle.price};
`;
export const Month = styled.div`
  ${planStyle.month}
`;

export const Offer = styled.div`
  ${planStyle.OfferBox}
`;
export const BackgroundWrapper = styled.div`
  ${pageStyle.backgroundWrapper}
  position: absolute;
`;
export const BackgroundGrid = styled.div`
  ${pageStyle.backgroundGrid}
  flex: 0 0 25%;
  @media screen and (min-width: 1200px) {
    flex: 0 0 25%;
  }
  @media screen and (min-width: 1800px) {
    flex: 0 0 25%;
  }
`;
